import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { TRANSLATIONS, SUPPORTED_LANGUAGES } from "./translations";

const LangContext = createContext(null);

const detectInitial = () => {
  const saved = typeof window !== "undefined" && localStorage.getItem("cd_lang");
  if (saved && SUPPORTED_LANGUAGES.includes(saved)) return saved;
  // User requested Hindi as the default language for everyone; browser locale is ignored.
  return "hi";
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(detectInitial);

  useEffect(() => {
    localStorage.setItem("cd_lang", lang);
    document.documentElement.setAttribute("lang", lang);
  }, [lang]);

  const setLang = (l) => {
    if (SUPPORTED_LANGUAGES.includes(l)) setLangState(l);
  };

  const t = useMemo(() => {
    const dict = TRANSLATIONS[lang] || TRANSLATIONS.en;
    return (key, vars) => {
      let s = dict[key] ?? TRANSLATIONS.en[key] ?? key;
      if (vars) {
        Object.keys(vars).forEach((k) => {
          s = s.replaceAll(`{${k}}`, String(vars[k]));
        });
      }
      return s;
    };
  }, [lang]);

  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be used inside LanguageProvider");
  return ctx;
};
